import { render, staticRenderFns } from "./upload_file.vue?vue&type=template&id=9c51bf0a&scoped=true"
import script from "./upload_file.vue?vue&type=script&lang=js"
export * from "./upload_file.vue?vue&type=script&lang=js"
import style0 from "./upload_file.vue?vue&type=style&index=0&id=9c51bf0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c51bf0a",
  null
  
)

export default component.exports